module.exports = __webpack_public_path__ + "img/desjardins.b01d4281.webp";